const circleBranch = process.env.CIRCLE_BRANCH

const envObj = {
  API_URL: process.env.API_URL,
  APP_URL: process.env.APP_URL || 'http://localhost:8081',
  APPLICATION_KEY: process.env.APPLICATION_KEY || 'pingu123',
  BASE_PATH:
    typeof process.env.BASE_PATH !== 'undefined'
      ? process.env.BASE_PATH
      : '/prokit',

  PLATFORM_URL: process.env.PLATFORM_URL || '',

  MAILTO: process.env.MAILTO || 'sales@datawow.io,support@ndatathoth.com',
  EMAIL_API_URL: process.env.EMAIL_API_URL,

  BLOG_BASE_PATH: process.env.BLOG_BASE_PATH || '/blogs',
  PDPA_BLOG_API_KEY: process.env.PDPA_BLOG_API_KEY,
  PDPA_BLOG_API_URL: process.env.PDPA_BLOG_API_URL,

  CONSENT_WOW_API_URL: process.env.CONSENT_WOW_API_URL || '',
  CONSENT_WOW_CONTACT_API_KEY:
    process.env.STAGING_CONSENT_WOW_CONTACT_API_KEY || '',
  CONSENT_WOW_MARKETING_CONSENT_PURPOSE_ID:
    process.env.STAGING_CONSENT_WOW_MARKETING_CONSENT_PURPOSE_ID || '',

  SLACK_WEBHOOK_URL: process.env.STAGING_SLACK_WEBHOOK_URL,

  GTM_CONTAINER_ID: '',

  NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_CLIENT_SCRIPT_URL:
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_CLIENT_SCRIPT_URL ||
    'https://challenges.cloudflare.com/turnstile/v0/api.js',
  NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY:
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY || '',
  NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SERVER_SCRIPT_URL:
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SERVER_SCRIPT_URL ||
    'https://challenges.cloudflare.com/turnstile/v0/siteverify',
  CLOUDFLARE_TURNSTILE_SECRET_KEY:
    process.env.CLOUDFLARE_TURNSTILE_SECRET_KEY || '',

  IS_DEV: process.env.NODE_ENV === 'development',
}

if (circleBranch === 'production') {
  envObj.GTM_CONTAINER_ID = process.env.GTM_CONTAINER_ID || ''
  envObj.APP_URL = process.env.PRODUCTION_APP_URL || ''
  envObj.API_URL = process.env.PRODUCTION_API_URL || ''
  envObj.PLATFORM_URL = process.env.PRODUCTION_PLATFORM_URL || ''
  envObj.APPLICATION_KEY = process.env.PRODUCTION_APP_KEY || ''
  envObj.CONSENT_WOW_CONTACT_API_KEY =
    process.env.PRODUCTION_CONSENT_WOW_CONTACT_API_KEY || ''
  envObj.CONSENT_WOW_MARKETING_CONSENT_PURPOSE_ID =
    process.env.PRODUCTION_CONSENT_WOW_MARKETING_CONSENT_PURPOSE_ID || ''
  envObj.SLACK_WEBHOOK_URL = process.env.PRODUCTION_SLACK_WEBHOOK_URL

  envObj.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_CLIENT_SCRIPT_URL =
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_CLIENT_SCRIPT_URL || ''
  envObj.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY =
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY || ''
  envObj.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SERVER_SCRIPT_URL =
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SERVER_SCRIPT_URL || ''
  envObj.CLOUDFLARE_TURNSTILE_SECRET_KEY =
    process.env.CLOUDFLARE_TURNSTILE_SECRET_KEY || ''
} else if (circleBranch === 'main') {
  envObj.APP_URL = process.env.STAGING_APP_URL || ''
  envObj.API_URL = process.env.STAGING_API_URL || ''
  envObj.PLATFORM_URL = process.env.STAGING_PLATFORM_URL || ''
  envObj.APPLICATION_KEY = process.env.STAGING_APP_KEY || ''
  envObj.SLACK_WEBHOOK_URL = process.env.STAGING_SLACK_WEBHOOK_URL

  envObj.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_CLIENT_SCRIPT_URL =
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_CLIENT_SCRIPT_URL || ''
  envObj.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY =
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY || ''
  envObj.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SERVER_SCRIPT_URL =
    process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SERVER_SCRIPT_URL || ''
  envObj.CLOUDFLARE_TURNSTILE_SECRET_KEY =
    process.env.CLOUDFLARE_TURNSTILE_SECRET_KEY || ''
}

export default { ...envObj }
